import React from 'react';

export const searchInputKeyboardShortcuts = (searchRef: React.RefObject<HTMLInputElement | null>) => {
  React.useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Alt+s to focus search field
      if (e.altKey && (e.key === 's' || e.key === 'ß')) {
        e.preventDefault();
        if (searchRef?.current) {
          searchRef.current.focus();
          searchRef.current.select();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [searchRef]);
};

export const refreshDevicesKeyboardShortcuts = (refresh: () => void) => {
  React.useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Alt+r to refresh device list
      if (e.altKey && (e.key === 'r' || e.key === '®')) {
        e.preventDefault();
        refresh();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
};

export const handleCommandKeyDown = (
  event: React.KeyboardEvent<HTMLElement>,
  command: string,
  payload: string | undefined,
  onSend: (command: string, payload?: string) => void
) => {
  if (event.key === 'Enter' && !event.ctrlKey) {
    event.preventDefault();
    if (command) {
      onSend(command, payload);
    }
  }
};

export const handlePayloadKeyDown = (
  event: React.KeyboardEvent<HTMLElement>,
  command: string,
  payload: string | undefined,
  onSend: (command: string, payload?: string) => void
) => {
  if (event.key === 'Enter' && event.ctrlKey) {
    event.preventDefault();
    if (command) {
      onSend(command, payload);
    }
  }
};

export const handleLabelKeyDown = (
  event: React.KeyboardEvent<HTMLElement>,
  currentValue: string,
  originalValue: string,
  onUpdate: (value: string) => Promise<void>
) => {
  if (event.key === 'Enter') {
    event.preventDefault();
    if (currentValue !== originalValue) {
      onUpdate(currentValue);
    }
  }
};